import React, { FC } from "react";
import PageWrapper from "../../layout/PageWrapper/PageWrapper";
import * as H from "../../styles/han/StyledComponentHan";

import end_mo_splash_00 from "../../images/sldfSplash/end_mo_splash_00.png";
import end_pc_splash_00 from "../../images/sldfSplash/end_pc_splash_00.png";

const SLDFPage: FC = () => {

  return (
    <>
      <PageWrapper title={'Welcome A.Black'}>
        <H.SplashWrap>
          <div> {/* 01 메인 */}
            <img src={end_mo_splash_00} alt="서울리빙디자인페어 종료" className="SplashView_mo" />
            <img src={end_pc_splash_00} alt="서울리빙디자인페어 종료" className="SplashView_pc" />
          </div>
          <div className="button-box">
            <button
              onClick={() => {
                window.open('https://naver.me/xNL2wR2C', '_blank', 'noopener,noreferrer');
              }}
            >
              <h3>더현대 서울</h3>
              <p>배르판 모노스토어 바로가기</p>
            </button>
            <button
              onClick={() => {
                window.open('https://naver.me/xY47njNW', '_blank', 'noopener,noreferrer');
              }}
            >
              <h3>현대백화점 판교</h3>
              <p>배르판 모노스토어 바로가기</p>
            </button>
          </div>
        </H.SplashWrap>
      </PageWrapper>
    </>
  )
};

export default SLDFPage;